import { createCheckoutSession } from "../../../api/services/stripeService";

const UpgradeButton = ({
  uid,
  plan,
  label,
  className = "plan-action-button primary-button",
  disabled = false,
}) => {
  const handleUpgrade = async () => {
    if (disabled) return;

    try {
      const { url } = await createCheckoutSession({ uid, plan });

      if (!url) {
        throw new Error("No checkout URL returned from server.");
      }

      window.location.href = url;
    } catch (error) {
      console.error("Stripe checkout error:", error?.response?.data || error);
      alert("Unable to start checkout. Please try again.");
    }
  };

  return (
    <button className={className} onClick={handleUpgrade} disabled={disabled}>
      {label || `Upgrade to ${plan}`}
    </button>
  );
};

export default UpgradeButton;
